import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Unsubscribable } from 'rxjs';
import { pluck, switchMap, take } from 'rxjs/operators';
import { CheckoutConstants } from 'src/app/model/checkout.model';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { LanguageExtendService } from 'src/app/service/language/language-extend.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import {
  TCPayload,
  TNCPayload,
  TermsAndConditionsService,
} from 'src/app/service/terms-and-conditions/terms-and-conditions.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
interface CountryTCSetting {
  showDate: boolean;
  tcLabel: string;
  tcLastUpdated: string;
}

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TermsAndConditionsComponent implements OnInit {
  data$: Observable<any> = this.component.data$;
  dataHandler: Unsubscribable;
  lang$: Observable<any>;
  currentDate = '';

  payload: TCPayload = { tncVersionNo: '' };
  tcPayload: TNCPayload = { userId: '' };
  errorMsg: any;
  tncAccepted: boolean;
  activeCountry$: Observable<string> = this.countryService.getActive();
  businessType: string;

  showDynamicDateFormat$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.DYNAMIC_DATE_FORMAT)
    )
  );

  dateFormat$: Observable<string> = this.baseStoreService.getBasestoreData().pipe(pluck('dateFormat'));
  countryHasCustomTCHeader: Set<string> = new Set<string>(['nl', 'tr', 'it', 'pt', 'es']);
  removeEnglishTCHeader: Set<string> = new Set<string>(['be', 'lu']);

  constructor(
    public component: CmsComponentData<any>,
    public datepipe: DatePipe,
    private tcService: TermsAndConditionsService,
    private router: Router,
    private langService: LanguageExtendService,
    private countryService: ShimanoCountryService,
    private checkoutServiceExtends: CheckoutServiceExtends,
    private baseStoreService: BaseStoreService,
    private languageService: ShimanoLanguageService,
    public currentBusinesstype: CurrentBusinessType
  ) {
    this.dataHandler = this.data$.subscribe((newitem) => {
      this.currentDate = newitem.updatedDate;
      this.payload.tncVersionNo = newitem.tncVersionNo;
      this.tcService.tncVersion.next(newitem.tncVersionNo);
    });
  }

  ngOnInit() {
    this.businessType = this.currentBusinesstype.getBusinessType();
  }

  getTermsStatus() {
    this.lang$ = this.langService.getShimanoActiveLanguage();
    this.lang$.pipe(take(1)).subscribe((data) => {
      const terms = { versionNo: '', acceptedDate: '' };
      terms.versionNo = data.tncVersionNo;
      terms.acceptedDate = data.tncAcceptedDate;
      return terms;
    });
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  acceptTerms() {
    this.tcService
      .updateTC(this.payload)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.router.navigate(['/']);
        },
        (err) => {}
      );
  }

  getClass(country: string): string {
    return this.businessType === 'fish' && country === 'ca' ? '' : country;
  }
  countryTermsSetting(country: string, language: string): CountryTCSetting {
    let customCountryTCSetting: CountryTCSetting;
    const defaultSetting: CountryTCSetting = { showDate: true, tcLabel: '', tcLastUpdated: '' };

    if (this.businessType === 'fish' && this.countryHasCustomTCHeader.has(country)) {
      customCountryTCSetting = {
        showDate: true,
        tcLabel: 'Fish' + country.toUpperCase(),
        tcLastUpdated: 'Fish' + country.toUpperCase(),
      };
    } else if (this.businessType === 'fish' && this.removeEnglishTCHeader.has(country)) {
      // sbx countries with 3 languages, english will be removed from the terms and conditions
      customCountryTCSetting = {
        showDate: true,
        tcLabel: language === 'nl' ? 'FishNL' : 'FishFR',
        tcLastUpdated: language === 'nl' ? 'FishNL' : 'FishFR',
      };
    } else {
      const uniqueCountrySetting: { [key: string]: CountryTCSetting } = {
        us: { ...defaultSetting, showDate: false },
        ca: { ...defaultSetting, showDate: false, tcLabel: this.businessType === 'fish' ? '' : 'CA' },
      };
      customCountryTCSetting = uniqueCountrySetting[country] || defaultSetting;
    }

    return customCountryTCSetting;
  }
}
